module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17506/js/img/valuePropModals/ReportBuilderAndMultipleEmailSignatures/ValueProp1.svg"